import { Hero } from '../components/Hero';
import { Experiences } from '../components/Experiences';
import { Includes } from '../components/Includes';
import { CTA } from '../components/CTA';

export function Home() {
  return (
    <>
      <Hero />
      <Experiences />
      <Includes />
      <CTA />
    </>
  );
}
